import { render, staticRenderFns } from "./VariableRegioSanitaria.vue?vue&type=template&id=24b9cb86&"
import script from "./VariableRegioSanitaria.vue?vue&type=script&lang=js&"
export * from "./VariableRegioSanitaria.vue?vue&type=script&lang=js&"
import style0 from "./VariableRegioSanitaria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports